var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2190_1299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.584 16.1455H4.61523C3.23669 16.1455 2.11523 15.024 2.11523 13.6455V5.17676C2.11523 3.79822 3.23669 2.67676 4.61523 2.67676H10.584C11.9625 2.67676 13.084 3.79822 13.084 5.17676V13.6455C13.084 15.024 11.9625 16.1455 10.584 16.1455ZM4.61523 3.92676C3.92603 3.92676 3.36523 4.48755 3.36523 5.17676V13.6455C3.36523 14.3347 3.92603 14.8955 4.61523 14.8955H10.584C11.2732 14.8955 11.834 14.3347 11.834 13.6455V5.17676C11.834 4.48755 11.2732 3.92676 10.584 3.92676H4.61523ZM15.584 12.083V2.64551C15.584 1.26697 14.4625 0.145508 13.084 0.145508H6.14648C5.80127 0.145508 5.52148 0.425293 5.52148 0.770508C5.52148 1.11572 5.80127 1.39551 6.14648 1.39551H13.084C13.7732 1.39551 14.334 1.9563 14.334 2.64551V12.083C14.334 12.4282 14.6138 12.708 14.959 12.708C15.3042 12.708 15.584 12.4282 15.584 12.083Z",
    fill: "#08A9E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2190_1299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.865234 0.145508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.a69f44ff39d26f864865d4e585231fcd.svg";
export { ForwardRef as ReactComponent };